import React, { FC, PropsWithChildren, ReactNode, useCallback } from 'react'
import { Button, Card, Radio } from 'antd'

type PropType = FC<PropsWithChildren<{
  title: string | ReactNode
  tabs?: { label: string, value: string }[]
  className?: string
  onTabChange?: (value: string) => void
  hasExport?: boolean
}>>

const Component: PropType = ({ title, tabs, className, children, hasExport, onTabChange }) => {

  const handleTabChange = useCallback((e) => {
    if(typeof onTabChange === 'function') {
      onTabChange(e.target.value)
    }
  }, [onTabChange])

  return (
    <Card
      title={
        <div className='flex align-center'>
          <div className='font-15 font-700'>{title}</div>
          {
            tabs && tabs[0] && <Radio.Group onChange={handleTabChange} size='small' optionType="button" options={tabs} defaultValue={tabs[0].value} />
          }
        </div>
      }
      size="small"
      extra={
        hasExport !== false && <Button type='primary' size='small'>导出Excel</Button>
      }
      className={className}
    >
      {children}
    </Card>
  )
}

export default Component
